module.exports = __webpack_public_path__ + "img/9788932009797.962e82df.jpg";